module.exports = __webpack_public_path__ + "img/logo-dos.4f24ad80.png";